(() => {
  let countryRequest;

  function detectCountry() {
    if (!countryRequest) {
      const root = window.Shopify?.routes?.root || "/";
      countryRequest = fetch(`${root}browsing_context_suggestions.json?country[enabled]=true`, {
        credentials: "same-origin"
      })
        .then((response) => {
          if (!response.ok) throw new Error("Country detection unavailable");
          return response.json();
        })
        .then((data) => {
          const country = data?.detected_values?.country;
          if (!country || !/^[A-Z]{2}$/i.test(country.handle) || !country.name) return null;
          return country;
        })
        .catch(() => null);
    }

    return countryRequest;
  }

  function updateCountry(container) {
    detectCountry().then((country) => {
      if (!country || !container.isConnected) return;

      const name = container.querySelector("[data-visitor-country-name]");
      const flag = container.querySelector("[data-visitor-country-flag]");
      if (!name || !flag) return;

      name.textContent = country.name;
      flag.src = `https://cdn.shopify.com/static/images/flags/${country.handle.toLowerCase()}.svg?width=36`;
      flag.hidden = false;
    });
  }

  function updateWithin(root) {
    if (root instanceof Element && root.matches("[data-visitor-country]")) updateCountry(root);
    root.querySelectorAll?.("[data-visitor-country]").forEach(updateCountry);
  }

  updateWithin(document);

  new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node instanceof Element) updateWithin(node);
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
